module.exports = __webpack_public_path__ + "img/ch18.b4537855.png";